<template>
  <div class="container my-3 my-md-5">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-heading mb-4">Land bearbeiten</h4>
            <b-form-group label-cols="3" label="ISO">
              <b-form-input v-model="iso" size="md" class=""> </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Name">
              <b-form-input v-model="name" size="md" class=""> </b-form-input>
            </b-form-group>
            <div class="col-6 pl-0">
              <b-form-group label-cols="6" class="flex-nowrap" label="Europa">
                <b-form-checkbox
                  v-model="isEurope"
                  :value="1"
                  :unchecked-value="0"
                >
                </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="d-flex">
              <div class="col-6 pl-0">
                <b-form-group label-cols="3" label="Sprache (1) ISO">
                  <b-form-input v-model="language1Iso" size="md" class="">
                  </b-form-input>
                </b-form-group>
              </div>
              <div class="col-6 pr-0">
                <b-form-group label-cols="3" label="Sprache (1)">
                  <b-form-input v-model="language1Name" size="md" class="">
                  </b-form-input>
                </b-form-group>
              </div>
            </div>
            <b-form-group label-cols="3" label="Dezimaltrenner">
              <b-form-input v-model="delimiterDecimal" size="md" class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Tausendertrenner">
              <b-form-input v-model="delimiterGroup" size="md" class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Währung (ISO)">
              <b-form-input v-model="currencyIso" size="md" class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Währung">
              <b-form-input v-model="currencyName" size="md" class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Umrechnung zu Euro">
              <b-form-input v-model="currencyToEuro" size="md" class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Umrechnung Euro zu Währung">
              <b-form-input v-model="euroToCurrency" size="md" class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Buchungskonto">
              <b-form-input v-model="bookingAccountNumber" size="md" class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Buchungskonto reduziert">
              <b-form-input v-model="bookingAccountReduced" size="md" class="">
              </b-form-input>
            </b-form-group>
            <b-form-group label-cols="3" label="Kostenstelle">
              <b-form-input v-model="costCenter" size="md" class="">
              </b-form-input>
            </b-form-group>
            <b-form-group
              label-cols="3"
              label="Shippingservice-Preselection-Gruppe"
            >
              <b-form-select
                v-model="shippingServicePreselectionGroupId"
                :options="groupsById"
                size="md"
                class="mb-2 mr-sm-2 mb-sm-0"
              ></b-form-select>
            </b-form-group>
            <b-btn
              variant="primary"
              class="float-right"
              @click="updateCountry()"
              >Speichern</b-btn
            >
          </div>
        </div>
      </div>
    </div>
    <modal-error-component v-model="modalError"></modal-error-component>
  </div>
</template>

<script>
export default {
  name: "CountryEdit",
  props: {
    country: {
      type: Object,
      required: true,
    },
    groupsById: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      iso: "",
      name: "",
      isEurope: false,
      language1Iso: "",
      language1Name: "",
      delimiterDecimal: "",
      delimiterGroup: "",
      currencyIso: "",
      currencyName: "",
      currencyToEuro: 0.0,
      euroToCurrency: 0.0,
      bookingAccountNumber: 0,
      bookingAccountReduced: 0,
      costCenter: 0,
      shippingServicePreselectionGroupId: "",
      requestInProgress: false,
      modalError: {
        show: false,
        message: "",
        error: "",
        title: "",
      },
    };
  },
  methods: {
    updateCountry() {
      this.requestInProgress = true;
      const payload = {
        countryIso: this.iso,
        countryName: this.name,
        isEurope: this.isEurope,
        language1Iso: this.language1Iso,
        language1Name: this.language1Name,
        delimiterDecimal: this.delimiterDecimal,
        delimiterGroup: this.delimiterGroup,
        currencyIso: this.currencyIso,
        currencyName: this.currencyName,
        currencyToEuro: this.currencyToEuro,
        euroToCurrency: this.euroToCurrency,
        bookingAccountNumber: this.bookingAccountNumber,
        bookingAccountReduced: this.bookingAccountReduced,
        costCenter: this.costCenter,
        shippingServicePreselectionGroupId:
          this.shippingServicePreselectionGroupId,
      };

      axios
        .put(`/country/${this.country.id}`, payload)
        .then(() => {
          this.requestInProgress = false;
          this.$bvToast.toast("Änderungen wurden erfolgreich bearbeitet", {
            title: "Update erfolgreich",
            variant: "success",
            autoHideDelay: 5000,
          });
          setTimeout(() => {
            window.location.href = "/country";
          }, 3000);
        })
        .catch((error) => {
          this.requestInProgress = false;
          this.modalError = {
            show: true,
            message: "Ein Fehler ist aufgetreten",
            error:
              error.response?.data?.message ??
              error.response?.data ??
              error.message ??
              error,
            title: "Update fehlgeschlagen",
          };
        });
    },
  },
  mounted() {
    this.iso = this.country.countryIso;
    this.name = this.country.countryName;
    this.isEurope = this.country.isEurope;
    this.language1Iso = this.country.language1Iso;
    this.language1Name = this.country.language1Name;
    this.delimiterDecimal = this.country.delimiterDecimal;
    this.delimiterGroup = this.country.delimiterGroup;
    this.currencyIso = this.country.currencyIso;
    this.currencyName = this.country.currencyName;
    this.currencyToEuro = this.country.currencyToEuro;
    this.euroToCurrency = this.country.euroToCurrency;
    this.bookingAccountNumber = this.country.bookingAccountNumber;
    this.bookingAccountReduced = this.country.bookingAccountReduced;
    this.costCenter = this.country.costCenter;
  },
};
</script>
